// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tracking-monitoreo-form {
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  min-height: 0;
  height: auto !important;
  max-height: none;
  margin: 0 !important;
  overflow: visible;
  box-sizing: border-box;
}

.tracking-monitoreo-form > .row:first-child {
  flex: none;
  display: flex !important;
  flex-direction: column !important;
  min-width: 0;
  width: 100%;
  max-width: 100%;
  margin: 0 !important;
  padding: 0;
}

.tracking-monitoreo-form > .row:first-child > [class*="col-"] {
  display: grid !important;
  grid-template-columns: 195px minmax(0, 1fr);
  align-items: center;
  width: 100% !important;
  max-width: 100% !important;
  min-width: 0;
  margin: 0 !important;
  padding: 3px 0;
}

.tracking-monitoreo-form > .row:first-child > .columnsStyles {
  flex: 0 0 auto !important;
}

.tracking-monitoreo-form > .row:first-child > [class*="col-"] > [class*="col-"] {
  width: auto !important;
  max-width: none !important;
  min-width: 0;
  margin: 0 !important;
  padding: 0 8px 0 0;
  flex: none !important;
}

.tracking-monitoreo-form .Input,
.tracking-monitoreo-form .InputSelectReportSeguimihnetoSol,
.tracking-monitoreo-form .TextAreaReportSe2 {
  width: 100% !important;
  max-width: 100% !important;
  min-width: 0;
  box-sizing: border-box;
}

.tracking-monitoreo-form .TextAreaReportSe2 {
  min-height: 74px;
}

.tracking-monitoreo-form .ButtonWrapper {
  grid-column: 2;
  display: flex !important;
  align-items: center;
  justify-content: flex-end !important;
  gap: 10px;
  width: 100%;
  margin: 8px 0 0 !important;
  transform: none !important;
  position: static !important;
}

.tracking-monitoreo-form .ButtonWrapper .Button {
  min-width: 120px;
}

.tracking-monitoreo-form > .row:last-child {
  display: block;
  flex: none;
  min-height: 0;
  width: 100%;
  max-width: 100%;
  margin: 8px 0 0;
  overflow: visible;
}

.tracking-monitoreo-form > .row:last-child > [class*="col-"] {
  display: flex;
  flex: none;
  flex-direction: column;
  min-width: 0;
  min-height: 0;
  width: 100% !important;
  max-width: 100% !important;
  padding: 0;
}

.tracking-monitoreo-form .tracking-real-time-table-card {
  display: flex;
  flex: none;
  height: 280px;
  min-height: 160px;
  max-height: 280px;
  width: 100%;
  max-width: 100%;
  overflow: hidden;
}

/* El componente hereda ContainerTableReportesSolicitudes; se neutraliza
   únicamente aquí el overflow horizontal que trae la hoja global. */
.tracking-monitoreo-form .ContainerTableReportesSolicitudes {
  display: flex;
  flex: none;
  min-width: 0;
  min-height: 0;
  width: 100%;
  max-width: 100%;
  overflow: hidden !important;
  box-sizing: border-box;
}

.tracking-monitoreo-form .tracking-real-time-table-scroll {
  position: relative;
  flex: none;
  height: 100% !important;
  min-height: 0;
  width: 100%;
  max-width: 100%;
  overflow-x: hidden !important;
  overflow-y: auto !important;
  scrollbar-width: thin;
  scrollbar-color: #9eb4c5 transparent;
  isolation: isolate;
}

.tracking-monitoreo-form .tracking-real-time-table-scroll::-webkit-scrollbar {
  width: 5px;
  height: 0;
}

.tracking-monitoreo-form .tracking-real-time-table-scroll::-webkit-scrollbar-track {
  background: transparent;
}

.tracking-monitoreo-form .tracking-real-time-table-scroll::-webkit-scrollbar-thumb {
  border-radius: 999px;
  background: #9eb4c5;
}

.tracking-monitoreo-form .tracking-real-time-table {
  width: 100% !important;
  max-width: 100% !important;
  min-width: 0 !important;
  table-layout: fixed !important;
  border-collapse: collapse;
}

.tracking-monitoreo-form .tracking-real-time-table th,
.tracking-monitoreo-form .tracking-real-time-table td {
  min-width: 0 !important;
  max-width: 100%;
  padding: 4px 3px !important;
  font-size: 0.74rem !important;
  line-height: 1.2;
  white-space: normal !important;
  overflow-wrap: anywhere;
  word-break: break-word;
  box-sizing: border-box;
}

.tracking-monitoreo-form .tracking-real-time-table thead th {
  position: sticky;
  top: 0;
  z-index: 5;
  height: 30px;
  background: #006699 !important;
  color: #fff !important;
  background-clip: padding-box;
  box-shadow: inset 0 -1px 0 rgba(255, 255, 255, 0.35);
}

.tracking-monitoreo-form .tracking-real-time-table thead {
  position: sticky;
  top: 0;
  z-index: 4;
}

.tracking-monitoreo-form .tracking-date-header,
.tracking-monitoreo-form .tracking-observations-header {
  padding: 3px 2px !important;
  font-size: 0.68rem !important;
}

.tracking-monitoreo-form .tracking-action-cell,
.tracking-monitoreo-form .tracking-actions-header {
  text-align: center;
  overflow: visible !important;
}

.tracking-monitoreo-form .tracking-action-menu {
  position: relative;
  display: inline-block;
}

.tracking-monitoreo-form .tracking-action-trigger {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 24px;
  padding: 0 2px;
  border: 0;
  color: #006699;
  background: transparent;
  cursor: pointer;
}

.tracking-monitoreo-form .tracking-action-trigger i {
  font-size: 17px;
}

.tracking-monitoreo-form .tracking-action-dropdown {
  position: absolute;
  top: calc(100% + 4px);
  right: 0;
  z-index: 20;
  min-width: 105px;
  padding: 4px;
  border: 1px solid #d5e3ef;
  border-radius: 7px;
  background: #fff;
  box-shadow: 0 6px 16px rgba(15, 23, 42, 0.2);
}

.tracking-monitoreo-form .tracking-action-dropdown button {
  display: flex;
  align-items: center;
  gap: 6px;
  width: 100%;
  padding: 5px 7px;
  border: 0;
  border-radius: 4px;
  color: #174a6b;
  background: transparent;
  font-size: 11px;
  text-align: left;
  cursor: pointer;
}

.tracking-monitoreo-form .tracking-action-dropdown button:hover {
  background: #edf6ff;
}

/* Vista integrada: las tabs y el thead comparten un único scroll. */
.tracking-monitoring-host {
  --tracking-tabs-height: 44px;
}

.tracking-monitoring-host > .content {
  position: relative;
  min-height: 0 !important;
  overflow-x: hidden !important;
  overflow-y: auto !important;
}

.tracking-monitoring-host > .tabs {
  position: sticky;
  top: 0;
  z-index: 30;
  min-height: var(--tracking-tabs-height);
  background: #fff;
}

.tracking-monitoring-host > .content > .containerReporteContratoSeguimiento {
  height: auto !important;
  max-height: none !important;
  overflow: visible !important;
}

.tracking-monitoring-host .tracking-monitoreo-form {
  height: auto !important;
  max-height: none !important;
  overflow: visible !important;
}

.tracking-monitoring-host .tracking-real-time-table-card,
.tracking-monitoring-host .tracking-real-time-table-scroll {
  height: auto !important;
  max-height: none !important;
  overflow: visible !important;
}

.tracking-monitoring-host .tracking-real-time-table thead,
.tracking-monitoring-host .tracking-real-time-table thead th {
  position: sticky !important;
  top: 0 !important;
  z-index: 20 !important;
  background: #006699 !important;
  color: #fff !important;
}

.tracking-monitoring-host > .content::-webkit-scrollbar {
  width: 5px;
  height: 0;
}

.tracking-monitoring-host > .content::-webkit-scrollbar-track {
  background: transparent;
}

.tracking-monitoring-host > .content::-webkit-scrollbar-thumb {
  border-radius: 999px;
  background: #9eb4c5;
}

/* Scroll visual consistente para la pestaña Lista mensajes. */
.tracking-list-messages-scroll {
  overflow-x: hidden !important;
  overflow-y: auto !important;
  scrollbar-width: thin;
  scrollbar-color: #9eb4c5 transparent;
}

.tracking-list-messages-scroll::-webkit-scrollbar {
  width: 5px;
  height: 0;
}

.tracking-list-messages-scroll::-webkit-scrollbar-track {
  background: transparent;
}

.tracking-list-messages-scroll::-webkit-scrollbar-thumb {
  border-radius: 999px;
  background: #9eb4c5;
}

.tracking-list-messages-scroll::-webkit-scrollbar-button,
.tracking-list-messages-scroll::-webkit-scrollbar:horizontal {
  display: none;
}

/* El mapa necesita una altura real en móvil. Sin esta altura, el 100% de
   .seguimiento-map se calcula sobre una fila sin alto y termina colapsado. */
@media (max-width: 768px) {
  .seguimiento-modal .seguimiento-content-row {
    display: flex !important;
    flex-direction: column !important;
    width: 100%;
    min-width: 0;
    margin: 0;
  }

  .seguimiento-modal .seguimiento-content-row > [class*="col-"] {
    display: flex !important;
    flex: 0 0 100% !important;
    width: 100% !important;
    max-width: 100% !important;
    min-width: 0;
    padding-left: 0;
    padding-right: 0;
  }

  .seguimiento-modal .seguimiento-map-shell {
    display: block !important;
    width: 100%;
    height: 320px;
    min-height: 320px;
    margin-bottom: 10px;
  }

  .seguimiento-modal .seguimiento-content-row .seguimiento-map {
    display: block;
    width: 100%;
    height: 100%;
    min-height: 320px !important;
  }

  .seguimiento-modal .seguimiento-content-panel {
    width: 100%;
    min-width: 0;
  }
}

@media (max-width: 480px) {
  .seguimiento-modal .seguimiento-map-shell,
  .seguimiento-modal .seguimiento-content-row .seguimiento-map {
    height: 270px;
    min-height: 270px !important;
  }
}

@media (max-width: 768px) {
  .tracking-monitoreo-form {
    height: auto !important;
    max-height: none;
    overflow: visible;
  }

  .tracking-monitoreo-form > .row:first-child > [class*="col-"] {
    grid-template-columns: 112px minmax(0, 1fr);
    gap: 5px;
    padding: 4px 0;
  }

  .tracking-monitoreo-form > .row:first-child > [class*="col-"] > [class*="col-"] {
    padding-right: 0;
  }

  .tracking-monitoreo-form .LabelTracking,
  .tracking-monitoreo-form .Label {
    font-size: 0.75rem;
    line-height: 1.15;
  }

  .tracking-monitoreo-form .Input,
  .tracking-monitoreo-form .InputSelectReportSeguimihnetoSol,
  .tracking-monitoreo-form .TextAreaReportSe2 {
    min-width: 0 !important;
    font-size: 0.78rem;
  }

  .tracking-monitoreo-form .TextAreaReportSe2 {
    min-height: 62px;
  }

  .tracking-monitoreo-form .ButtonWrapper {
    grid-column: 2;
    flex-wrap: wrap;
    justify-content: flex-start !important;
    gap: 6px;
  }

  .tracking-monitoreo-form .ButtonWrapper .Button {
    min-width: 0;
    flex: 1 1 110px;
    padding: 7px 10px;
    font-size: 0.78rem;
  }

  .tracking-monitoreo-form .tracking-real-time-table-card {
    height: 220px;
    max-height: 220px;
  }

  .tracking-monitoreo-form .ContainerTableReportesSolicitudes {
    height: 220px;
    max-height: 220px;
  }

  .tracking-monitoreo-form .tracking-real-time-table th,
  .tracking-monitoreo-form .tracking-real-time-table td {
    padding: 4px 2px !important;
    font-size: 0.68rem !important;
  }
}

@media (max-width: 576px) {
  .tracking-monitoreo-form {
    padding: 0 10px;
  }

  .tracking-monitoreo-form > .row:first-child > [class*="col-"] {
    display: flex !important;
    flex-direction: column !important;
    align-items: stretch;
    gap: 3px;
    padding: 6px 0;
  }

  .tracking-monitoreo-form > .row:first-child > [class*="col-"] > [class*="col-"] {
    width: 100% !important;
    max-width: 100% !important;
    padding: 0;
  }

  .tracking-monitoreo-form .InputTooltipWrapper,
  .tracking-monitoreo-form .contToltip {
    display: flex;
    align-items: center;
    min-height: 20px;
  }

  .tracking-monitoreo-form .LabelTracking,
  .tracking-monitoreo-form .Label {
    font-size: 0.78rem;
    font-weight: 700;
  }

  .tracking-monitoreo-form .Input,
  .tracking-monitoreo-form .InputSelectReportSeguimihnetoSol,
  .tracking-monitoreo-form .TextAreaReportSe2 {
    min-height: 38px;
    font-size: 0.84rem;
  }

  .tracking-monitoreo-form .TextAreaReportSe2 {
    min-height: 90px;
  }

  .tracking-monitoreo-form .ButtonWrapper {
    display: grid !important;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    grid-column: auto;
    width: 100%;
  }

  .tracking-monitoreo-form .ButtonWrapper .Button {
    width: 100%;
    min-width: 0;
  }

  .tracking-monitoreo-form .tracking-real-time-table-card {
    height: 240px;
    max-height: 240px;
    border-radius: 10px;
  }

  .tracking-monitoreo-form .ContainerTableReportesSolicitudes {
    height: 240px;
    max-height: 240px;
    border-radius: 10px;
  }

  .tracking-monitoreo-form .tracking-real-time-table th,
  .tracking-monitoreo-form .tracking-real-time-table td {
    padding: 5px 2px !important;
    font-size: 0.66rem !important;
  }

  /* En móvil cada reporte se presenta como una tarjeta legible. */
  .tracking-monitoreo-form .tracking-real-time-table {
    display: block !important;
  }

  .tracking-monitoreo-form .tracking-real-time-table colgroup,
  .tracking-monitoreo-form .tracking-real-time-table thead {
    display: none;
  }

  .tracking-monitoreo-form .tracking-real-time-table tbody {
    display: grid;
    gap: 8px;
    padding: 8px;
  }

  .tracking-monitoreo-form .tracking-real-time-table tbody tr {
    display: grid;
    grid-template-columns: 64px minmax(0, 1fr) 24px;
    gap: 3px 8px;
    padding: 10px 8px;
    border: 1px solid #e1eaf2;
    border-radius: 10px;
    background: #fff;
    box-shadow: 0 3px 10px rgba(15, 23, 42, 0.07);
  }

  .tracking-monitoreo-form .tracking-real-time-table tbody td {
    display: block;
    width: auto !important;
    max-width: none;
    padding: 0 !important;
    border: 0;
    font-size: 0.72rem !important;
    line-height: 1.25;
    overflow: visible;
  }

  .tracking-monitoreo-form .tracking-real-time-table tbody td::before {
    display: block;
    margin-bottom: 2px;
    color: #71859a;
    font-size: 0.56rem;
    font-weight: 700;
    letter-spacing: 0.02em;
    text-transform: uppercase;
  }

  .tracking-monitoreo-form .tracking-real-time-table tbody td:nth-child(1) {
    grid-column: 1;
    grid-row: 1 / span 5;
    align-self: start;
    color: #173b60;
    font-weight: 700;
  }

  .tracking-monitoreo-form .tracking-real-time-table tbody td:nth-child(1)::before { content: "Fecha"; }
  .tracking-monitoreo-form .tracking-real-time-table tbody td:nth-child(2) { grid-column: 2; grid-row: 1; }
  .tracking-monitoreo-form .tracking-real-time-table tbody td:nth-child(2)::before { content: "Acción"; }
  .tracking-monitoreo-form .tracking-real-time-table tbody td:nth-child(3) { grid-column: 2; grid-row: 2; }
  .tracking-monitoreo-form .tracking-real-time-table tbody td:nth-child(3)::before { content: "Estado"; }
  .tracking-monitoreo-form .tracking-real-time-table tbody td:nth-child(4) { grid-column: 2; grid-row: 3; }
  .tracking-monitoreo-form .tracking-real-time-table tbody td:nth-child(4)::before { content: "Ubicación"; }
  .tracking-monitoreo-form .tracking-real-time-table tbody td:nth-child(5) { grid-column: 2; grid-row: 4; }
  .tracking-monitoreo-form .tracking-real-time-table tbody td:nth-child(5)::before { content: "Observación"; }
  .tracking-monitoreo-form .tracking-real-time-table tbody td:nth-child(6) { grid-column: 2; grid-row: 5; }
  .tracking-monitoreo-form .tracking-real-time-table tbody td:nth-child(6)::before { content: "Usuario"; }
  .tracking-monitoreo-form .tracking-real-time-table tbody td:nth-child(7) {
    grid-column: 3;
    grid-row: 1 / span 5;
    align-self: start;
  }

  .tracking-monitoreo-form .tracking-real-time-table tbody td:nth-child(7)::before {
    content: none;
  }
}

@media (max-width: 360px) {
  .tracking-monitoreo-form {
    padding: 0 6px;
  }

  .tracking-monitoreo-form .ButtonWrapper {
    grid-template-columns: 1fr;
  }

  .tracking-monitoreo-form .tracking-real-time-table th,
  .tracking-monitoreo-form .tracking-real-time-table td {
    font-size: 0.60rem !important;
  }
}

@media (max-width: 480px) {
  .tracking-monitoreo-form > .row:first-child > [class*="col-"] {
    grid-template-columns: 96px minmax(0, 1fr);
    gap: 4px;
  }

  .tracking-monitoreo-form .LabelTracking,
  .tracking-monitoreo-form .Label {
    font-size: 0.68rem;
  }

  .tracking-monitoreo-form .Input,
  .tracking-monitoreo-form .InputSelectReportSeguimihnetoSol,
  .tracking-monitoreo-form .TextAreaReportSe2 {
    font-size: 0.7rem;
  }

  .tracking-monitoreo-form .tracking-real-time-table th,
  .tracking-monitoreo-form .tracking-real-time-table td {
    font-size: 0.62rem !important;
  }
}

/* Lista responsive para móviles y tablets pequeñas. */
@media (max-width: 768px) {
  .tracking-monitoreo-form .ContainerTableReportesSolicitudes,
  .tracking-monitoreo-form .tracking-real-time-table-card {
    height: 250px !important;
    max-height: 250px !important;
    overflow: hidden !important;
  }

  .tracking-monitoreo-form .tracking-real-time-table-scroll {
    height: 100% !important;
    max-height: none !important;
    overflow-x: hidden !important;
    overflow-y: auto !important;
    scrollbar-width: thin;
    scrollbar-color: #9eb4c5 transparent;
  }

  .tracking-monitoreo-form .tracking-real-time-table-scroll::-webkit-scrollbar {
    width: 5px;
    height: 0;
  }

  .tracking-monitoreo-form .tracking-real-time-table-scroll::-webkit-scrollbar-track {
    background: transparent;
  }

  .tracking-monitoreo-form .tracking-real-time-table-scroll::-webkit-scrollbar-thumb {
    border-radius: 999px;
    background: #9eb4c5;
  }

  .tracking-monitoreo-form .tracking-real-time-table {
    display: block !important;
    width: 100% !important;
  }

  .tracking-monitoreo-form .tracking-real-time-table colgroup,
  .tracking-monitoreo-form .tracking-real-time-table thead {
    display: none;
  }

  .tracking-monitoreo-form .tracking-real-time-table tbody {
    display: grid;
    gap: 8px;
    padding: 8px;
  }

  .tracking-monitoreo-form .tracking-real-time-table tbody tr {
    display: grid;
    grid-template-columns: 62px minmax(0, 1fr) 24px;
    gap: 4px 8px;
    padding: 10px 8px;
    border: 1px solid #e1eaf2;
    border-radius: 10px;
    background: #fff;
    box-shadow: 0 3px 10px rgba(15, 23, 42, 0.07);
  }

  .tracking-monitoreo-form .tracking-real-time-table tbody td {
    display: block;
    width: auto !important;
    max-width: none;
    padding: 0 !important;
    border: 0;
    font-size: 0.7rem !important;
    line-height: 1.25;
    overflow: visible;
    white-space: normal !important;
    overflow-wrap: anywhere;
  }

  .tracking-monitoreo-form .tracking-real-time-table tbody td::before {
    display: block;
    margin-bottom: 2px;
    color: #71859a;
    font-size: 0.54rem;
    font-weight: 700;
    letter-spacing: 0.02em;
    text-transform: uppercase;
  }

  .tracking-monitoreo-form .tracking-real-time-table tbody td:nth-child(1) {
    grid-column: 1;
    grid-row: 1 / span 5;
    align-self: start;
    color: #173b60;
    font-weight: 700;
  }

  .tracking-monitoreo-form .tracking-real-time-table tbody td:nth-child(1)::before { content: "Fecha"; }
  .tracking-monitoreo-form .tracking-real-time-table tbody td:nth-child(2) { grid-column: 2; grid-row: 1; }
  .tracking-monitoreo-form .tracking-real-time-table tbody td:nth-child(2)::before { content: "Acción"; }
  .tracking-monitoreo-form .tracking-real-time-table tbody td:nth-child(3) { grid-column: 2; grid-row: 2; }
  .tracking-monitoreo-form .tracking-real-time-table tbody td:nth-child(3)::before { content: "Estado"; }
  .tracking-monitoreo-form .tracking-real-time-table tbody td:nth-child(4) { grid-column: 2; grid-row: 3; }
  .tracking-monitoreo-form .tracking-real-time-table tbody td:nth-child(4)::before { content: "Ubicación"; }
  .tracking-monitoreo-form .tracking-real-time-table tbody td:nth-child(5) { grid-column: 2; grid-row: 4; }
  .tracking-monitoreo-form .tracking-real-time-table tbody td:nth-child(5)::before { content: "Observación"; }
  .tracking-monitoreo-form .tracking-real-time-table tbody td:nth-child(6) { grid-column: 2; grid-row: 5; }
  .tracking-monitoreo-form .tracking-real-time-table tbody td:nth-child(6)::before { content: "Usuario"; }
  .tracking-monitoreo-form .tracking-real-time-table tbody td:nth-child(7) {
    grid-column: 3;
    grid-row: 1 / span 5;
    align-self: start;
  }

  .tracking-monitoreo-form .tracking-real-time-table tbody td:nth-child(7)::before {
    content: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Pages/Css/trackingMonitoreo.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,eAAe;EACf,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,gBAAgB;EAChB,oBAAoB;EACpB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,UAAU;EACV,wBAAwB;EACxB,iCAAiC;EACjC,YAAY;EACZ,WAAW;EACX,eAAe;EACf,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,wBAAwB;EACxB,2CAA2C;EAC3C,mBAAmB;EACnB,sBAAsB;EACtB,0BAA0B;EAC1B,YAAY;EACZ,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,0BAA0B;EAC1B,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;;;EAGE,sBAAsB;EACtB,0BAA0B;EAC1B,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,wBAAwB;EACxB,mBAAmB;EACnB,oCAAoC;EACpC,SAAS;EACT,WAAW;EACX,0BAA0B;EAC1B,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,UAAU;EACV,aAAa;EACb,WAAW;EACX,eAAe;EACf,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,UAAU;EACV,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,0BAA0B;EAC1B,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,UAAU;EACV,aAAa;EACb,iBAAiB;EACjB,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;oEACoE;AACpE;EACE,aAAa;EACb,UAAU;EACV,YAAY;EACZ,aAAa;EACb,WAAW;EACX,eAAe;EACf,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,uBAAuB;EACvB,aAAa;EACb,WAAW;EACX,eAAe;EACf,6BAA6B;EAC7B,2BAA2B;EAC3B,qBAAqB;EACrB,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,SAAS;AACX;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,0BAA0B;EAC1B,uBAAuB;EACvB,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;;EAEE,uBAAuB;EACvB,eAAe;EACf,2BAA2B;EAC3B,6BAA6B;EAC7B,gBAAgB;EAChB,8BAA8B;EAC9B,uBAAuB;EACvB,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,YAAY;EACZ,8BAA8B;EAC9B,sBAAsB;EACtB,4BAA4B;EAC5B,oDAAoD;AACtD;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;AACZ;;AAEA;;EAEE,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA;;EAEE,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,SAAS;EACT,cAAc;EACd,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,QAAQ;EACR,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,gBAAgB;EAChB,SAAS;EACT,kBAAkB;EAClB,cAAc;EACd,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,oEAAoE;AACpE;EACE,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,6BAA6B;EAC7B,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,WAAW;EACX,uCAAuC;EACvC,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,uBAAuB;EACvB,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;;EAEE,uBAAuB;EACvB,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;;EAEE,2BAA2B;EAC3B,iBAAiB;EACjB,sBAAsB;EACtB,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;EACE,UAAU;EACV,SAAS;AACX;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA,8DAA8D;AAC9D;EACE,6BAA6B;EAC7B,2BAA2B;EAC3B,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA;EACE,UAAU;EACV,SAAS;AACX;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;;EAEE,aAAa;AACf;;AAEA;6EAC6E;AAC7E;EACE;IACE,wBAAwB;IACxB,iCAAiC;IACjC,WAAW;IACX,YAAY;IACZ,SAAS;EACX;;EAEA;IACE,wBAAwB;IACxB,yBAAyB;IACzB,sBAAsB;IACtB,0BAA0B;IAC1B,YAAY;IACZ,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;IACzB,WAAW;IACX,aAAa;IACb,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,WAAW;IACX,YAAY;IACZ,4BAA4B;EAC9B;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE;;IAEE,aAAa;IACb,4BAA4B;EAC9B;AACF;;AAEA;EACE;IACE,uBAAuB;IACvB,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,2CAA2C;IAC3C,QAAQ;IACR,cAAc;EAChB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;;IAEE,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;;;IAGE,uBAAuB;IACvB,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,cAAc;IACd,eAAe;IACf,sCAAsC;IACtC,QAAQ;EACV;;EAEA;IACE,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,iBAAiB;EACnB;;EAEA;;IAEE,2BAA2B;IAC3B,6BAA6B;EAC/B;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,wBAAwB;IACxB,iCAAiC;IACjC,oBAAoB;IACpB,QAAQ;IACR,cAAc;EAChB;;EAEA;IACE,sBAAsB;IACtB,0BAA0B;IAC1B,UAAU;EACZ;;EAEA;;IAEE,aAAa;IACb,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;;IAEE,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;;;IAGE,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,wBAAwB;IACxB,gDAAgD;IAChD,iBAAiB;IACjB,WAAW;EACb;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,aAAa;IACb,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;;IAEE,2BAA2B;IAC3B,6BAA6B;EAC/B;;EAEA,gEAAgE;EAChE;IACE,yBAAyB;EAC3B;;EAEA;;IAEE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,QAAQ;IACR,YAAY;EACd;;EAEA;IACE,aAAa;IACb,+CAA+C;IAC/C,YAAY;IACZ,iBAAiB;IACjB,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;IAChB,6CAA6C;EAC/C;;EAEA;IACE,cAAc;IACd,sBAAsB;IACtB,eAAe;IACf,qBAAqB;IACrB,SAAS;IACT,6BAA6B;IAC7B,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,cAAc;IACd,kBAAkB;IAClB,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;EAC3B;;EAEA;IACE,cAAc;IACd,oBAAoB;IACpB,iBAAiB;IACjB,cAAc;IACd,gBAAgB;EAClB;;EAEA,mFAAmF,gBAAgB,EAAE;EACrG,2EAA2E,cAAc,EAAE,WAAW,EAAE;EACxG,mFAAmF,iBAAiB,EAAE;EACtG,2EAA2E,cAAc,EAAE,WAAW,EAAE;EACxG,mFAAmF,iBAAiB,EAAE;EACtG,2EAA2E,cAAc,EAAE,WAAW,EAAE;EACxG,mFAAmF,oBAAoB,EAAE;EACzG,2EAA2E,cAAc,EAAE,WAAW,EAAE;EACxG,mFAAmF,sBAAsB,EAAE;EAC3G,2EAA2E,cAAc,EAAE,WAAW,EAAE;EACxG,mFAAmF,kBAAkB,EAAE;EACvG;IACE,cAAc;IACd,oBAAoB;IACpB,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,cAAc;EAChB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;;IAEE,6BAA6B;EAC/B;AACF;;AAEA;EACE;IACE,0CAA0C;IAC1C,QAAQ;EACV;;EAEA;;IAEE,kBAAkB;EACpB;;EAEA;;;IAGE,iBAAiB;EACnB;;EAEA;;IAEE,6BAA6B;EAC/B;AACF;;AAEA,sDAAsD;AACtD;EACE;;IAEE,wBAAwB;IACxB,4BAA4B;IAC5B,2BAA2B;EAC7B;;EAEA;IACE,uBAAuB;IACvB,2BAA2B;IAC3B,6BAA6B;IAC7B,2BAA2B;IAC3B,qBAAqB;IACrB,oCAAoC;EACtC;;EAEA;IACE,UAAU;IACV,SAAS;EACX;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,oBAAoB;IACpB,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;IACzB,sBAAsB;EACxB;;EAEA;;IAEE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,QAAQ;IACR,YAAY;EACd;;EAEA;IACE,aAAa;IACb,+CAA+C;IAC/C,YAAY;IACZ,iBAAiB;IACjB,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;IAChB,6CAA6C;EAC/C;;EAEA;IACE,cAAc;IACd,sBAAsB;IACtB,eAAe;IACf,qBAAqB;IACrB,SAAS;IACT,4BAA4B;IAC5B,iBAAiB;IACjB,iBAAiB;IACjB,8BAA8B;IAC9B,uBAAuB;EACzB;;EAEA;IACE,cAAc;IACd,kBAAkB;IAClB,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;EAC3B;;EAEA;IACE,cAAc;IACd,oBAAoB;IACpB,iBAAiB;IACjB,cAAc;IACd,gBAAgB;EAClB;;EAEA,mFAAmF,gBAAgB,EAAE;EACrG,2EAA2E,cAAc,EAAE,WAAW,EAAE;EACxG,mFAAmF,iBAAiB,EAAE;EACtG,2EAA2E,cAAc,EAAE,WAAW,EAAE;EACxG,mFAAmF,iBAAiB,EAAE;EACtG,2EAA2E,cAAc,EAAE,WAAW,EAAE;EACxG,mFAAmF,oBAAoB,EAAE;EACzG,2EAA2E,cAAc,EAAE,WAAW,EAAE;EACxG,mFAAmF,sBAAsB,EAAE;EAC3G,2EAA2E,cAAc,EAAE,WAAW,EAAE;EACxG,mFAAmF,kBAAkB,EAAE;EACvG;IACE,cAAc;IACd,oBAAoB;IACpB,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":[".tracking-monitoreo-form {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  max-width: 100%;\n  min-width: 0;\n  min-height: 0;\n  height: auto !important;\n  max-height: none;\n  margin: 0 !important;\n  overflow: visible;\n  box-sizing: border-box;\n}\n\n.tracking-monitoreo-form > .row:first-child {\n  flex: none;\n  display: flex !important;\n  flex-direction: column !important;\n  min-width: 0;\n  width: 100%;\n  max-width: 100%;\n  margin: 0 !important;\n  padding: 0;\n}\n\n.tracking-monitoreo-form > .row:first-child > [class*=\"col-\"] {\n  display: grid !important;\n  grid-template-columns: 195px minmax(0, 1fr);\n  align-items: center;\n  width: 100% !important;\n  max-width: 100% !important;\n  min-width: 0;\n  margin: 0 !important;\n  padding: 3px 0;\n}\n\n.tracking-monitoreo-form > .row:first-child > .columnsStyles {\n  flex: 0 0 auto !important;\n}\n\n.tracking-monitoreo-form > .row:first-child > [class*=\"col-\"] > [class*=\"col-\"] {\n  width: auto !important;\n  max-width: none !important;\n  min-width: 0;\n  margin: 0 !important;\n  padding: 0 8px 0 0;\n  flex: none !important;\n}\n\n.tracking-monitoreo-form .Input,\n.tracking-monitoreo-form .InputSelectReportSeguimihnetoSol,\n.tracking-monitoreo-form .TextAreaReportSe2 {\n  width: 100% !important;\n  max-width: 100% !important;\n  min-width: 0;\n  box-sizing: border-box;\n}\n\n.tracking-monitoreo-form .TextAreaReportSe2 {\n  min-height: 74px;\n}\n\n.tracking-monitoreo-form .ButtonWrapper {\n  grid-column: 2;\n  display: flex !important;\n  align-items: center;\n  justify-content: flex-end !important;\n  gap: 10px;\n  width: 100%;\n  margin: 8px 0 0 !important;\n  transform: none !important;\n  position: static !important;\n}\n\n.tracking-monitoreo-form .ButtonWrapper .Button {\n  min-width: 120px;\n}\n\n.tracking-monitoreo-form > .row:last-child {\n  display: block;\n  flex: none;\n  min-height: 0;\n  width: 100%;\n  max-width: 100%;\n  margin: 8px 0 0;\n  overflow: visible;\n}\n\n.tracking-monitoreo-form > .row:last-child > [class*=\"col-\"] {\n  display: flex;\n  flex: none;\n  flex-direction: column;\n  min-width: 0;\n  min-height: 0;\n  width: 100% !important;\n  max-width: 100% !important;\n  padding: 0;\n}\n\n.tracking-monitoreo-form .tracking-real-time-table-card {\n  display: flex;\n  flex: none;\n  height: 280px;\n  min-height: 160px;\n  max-height: 280px;\n  width: 100%;\n  max-width: 100%;\n  overflow: hidden;\n}\n\n/* El componente hereda ContainerTableReportesSolicitudes; se neutraliza\n   únicamente aquí el overflow horizontal que trae la hoja global. */\n.tracking-monitoreo-form .ContainerTableReportesSolicitudes {\n  display: flex;\n  flex: none;\n  min-width: 0;\n  min-height: 0;\n  width: 100%;\n  max-width: 100%;\n  overflow: hidden !important;\n  box-sizing: border-box;\n}\n\n.tracking-monitoreo-form .tracking-real-time-table-scroll {\n  position: relative;\n  flex: none;\n  height: 100% !important;\n  min-height: 0;\n  width: 100%;\n  max-width: 100%;\n  overflow-x: hidden !important;\n  overflow-y: auto !important;\n  scrollbar-width: thin;\n  scrollbar-color: #9eb4c5 transparent;\n  isolation: isolate;\n}\n\n.tracking-monitoreo-form .tracking-real-time-table-scroll::-webkit-scrollbar {\n  width: 5px;\n  height: 0;\n}\n\n.tracking-monitoreo-form .tracking-real-time-table-scroll::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.tracking-monitoreo-form .tracking-real-time-table-scroll::-webkit-scrollbar-thumb {\n  border-radius: 999px;\n  background: #9eb4c5;\n}\n\n.tracking-monitoreo-form .tracking-real-time-table {\n  width: 100% !important;\n  max-width: 100% !important;\n  min-width: 0 !important;\n  table-layout: fixed !important;\n  border-collapse: collapse;\n}\n\n.tracking-monitoreo-form .tracking-real-time-table th,\n.tracking-monitoreo-form .tracking-real-time-table td {\n  min-width: 0 !important;\n  max-width: 100%;\n  padding: 4px 3px !important;\n  font-size: 0.74rem !important;\n  line-height: 1.2;\n  white-space: normal !important;\n  overflow-wrap: anywhere;\n  word-break: break-word;\n  box-sizing: border-box;\n}\n\n.tracking-monitoreo-form .tracking-real-time-table thead th {\n  position: sticky;\n  top: 0;\n  z-index: 5;\n  height: 30px;\n  background: #006699 !important;\n  color: #fff !important;\n  background-clip: padding-box;\n  box-shadow: inset 0 -1px 0 rgba(255, 255, 255, 0.35);\n}\n\n.tracking-monitoreo-form .tracking-real-time-table thead {\n  position: sticky;\n  top: 0;\n  z-index: 4;\n}\n\n.tracking-monitoreo-form .tracking-date-header,\n.tracking-monitoreo-form .tracking-observations-header {\n  padding: 3px 2px !important;\n  font-size: 0.68rem !important;\n}\n\n.tracking-monitoreo-form .tracking-action-cell,\n.tracking-monitoreo-form .tracking-actions-header {\n  text-align: center;\n  overflow: visible !important;\n}\n\n.tracking-monitoreo-form .tracking-action-menu {\n  position: relative;\n  display: inline-block;\n}\n\n.tracking-monitoreo-form .tracking-action-trigger {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 20px;\n  height: 24px;\n  padding: 0 2px;\n  border: 0;\n  color: #006699;\n  background: transparent;\n  cursor: pointer;\n}\n\n.tracking-monitoreo-form .tracking-action-trigger i {\n  font-size: 17px;\n}\n\n.tracking-monitoreo-form .tracking-action-dropdown {\n  position: absolute;\n  top: calc(100% + 4px);\n  right: 0;\n  z-index: 20;\n  min-width: 105px;\n  padding: 4px;\n  border: 1px solid #d5e3ef;\n  border-radius: 7px;\n  background: #fff;\n  box-shadow: 0 6px 16px rgba(15, 23, 42, 0.2);\n}\n\n.tracking-monitoreo-form .tracking-action-dropdown button {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  width: 100%;\n  padding: 5px 7px;\n  border: 0;\n  border-radius: 4px;\n  color: #174a6b;\n  background: transparent;\n  font-size: 11px;\n  text-align: left;\n  cursor: pointer;\n}\n\n.tracking-monitoreo-form .tracking-action-dropdown button:hover {\n  background: #edf6ff;\n}\n\n/* Vista integrada: las tabs y el thead comparten un único scroll. */\n.tracking-monitoring-host {\n  --tracking-tabs-height: 44px;\n}\n\n.tracking-monitoring-host > .content {\n  position: relative;\n  min-height: 0 !important;\n  overflow-x: hidden !important;\n  overflow-y: auto !important;\n}\n\n.tracking-monitoring-host > .tabs {\n  position: sticky;\n  top: 0;\n  z-index: 30;\n  min-height: var(--tracking-tabs-height);\n  background: #fff;\n}\n\n.tracking-monitoring-host > .content > .containerReporteContratoSeguimiento {\n  height: auto !important;\n  max-height: none !important;\n  overflow: visible !important;\n}\n\n.tracking-monitoring-host .tracking-monitoreo-form {\n  height: auto !important;\n  max-height: none !important;\n  overflow: visible !important;\n}\n\n.tracking-monitoring-host .tracking-real-time-table-card,\n.tracking-monitoring-host .tracking-real-time-table-scroll {\n  height: auto !important;\n  max-height: none !important;\n  overflow: visible !important;\n}\n\n.tracking-monitoring-host .tracking-real-time-table thead,\n.tracking-monitoring-host .tracking-real-time-table thead th {\n  position: sticky !important;\n  top: 0 !important;\n  z-index: 20 !important;\n  background: #006699 !important;\n  color: #fff !important;\n}\n\n.tracking-monitoring-host > .content::-webkit-scrollbar {\n  width: 5px;\n  height: 0;\n}\n\n.tracking-monitoring-host > .content::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.tracking-monitoring-host > .content::-webkit-scrollbar-thumb {\n  border-radius: 999px;\n  background: #9eb4c5;\n}\n\n/* Scroll visual consistente para la pestaña Lista mensajes. */\n.tracking-list-messages-scroll {\n  overflow-x: hidden !important;\n  overflow-y: auto !important;\n  scrollbar-width: thin;\n  scrollbar-color: #9eb4c5 transparent;\n}\n\n.tracking-list-messages-scroll::-webkit-scrollbar {\n  width: 5px;\n  height: 0;\n}\n\n.tracking-list-messages-scroll::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.tracking-list-messages-scroll::-webkit-scrollbar-thumb {\n  border-radius: 999px;\n  background: #9eb4c5;\n}\n\n.tracking-list-messages-scroll::-webkit-scrollbar-button,\n.tracking-list-messages-scroll::-webkit-scrollbar:horizontal {\n  display: none;\n}\n\n/* El mapa necesita una altura real en móvil. Sin esta altura, el 100% de\n   .seguimiento-map se calcula sobre una fila sin alto y termina colapsado. */\n@media (max-width: 768px) {\n  .seguimiento-modal .seguimiento-content-row {\n    display: flex !important;\n    flex-direction: column !important;\n    width: 100%;\n    min-width: 0;\n    margin: 0;\n  }\n\n  .seguimiento-modal .seguimiento-content-row > [class*=\"col-\"] {\n    display: flex !important;\n    flex: 0 0 100% !important;\n    width: 100% !important;\n    max-width: 100% !important;\n    min-width: 0;\n    padding-left: 0;\n    padding-right: 0;\n  }\n\n  .seguimiento-modal .seguimiento-map-shell {\n    display: block !important;\n    width: 100%;\n    height: 320px;\n    min-height: 320px;\n    margin-bottom: 10px;\n  }\n\n  .seguimiento-modal .seguimiento-content-row .seguimiento-map {\n    display: block;\n    width: 100%;\n    height: 100%;\n    min-height: 320px !important;\n  }\n\n  .seguimiento-modal .seguimiento-content-panel {\n    width: 100%;\n    min-width: 0;\n  }\n}\n\n@media (max-width: 480px) {\n  .seguimiento-modal .seguimiento-map-shell,\n  .seguimiento-modal .seguimiento-content-row .seguimiento-map {\n    height: 270px;\n    min-height: 270px !important;\n  }\n}\n\n@media (max-width: 768px) {\n  .tracking-monitoreo-form {\n    height: auto !important;\n    max-height: none;\n    overflow: visible;\n  }\n\n  .tracking-monitoreo-form > .row:first-child > [class*=\"col-\"] {\n    grid-template-columns: 112px minmax(0, 1fr);\n    gap: 5px;\n    padding: 4px 0;\n  }\n\n  .tracking-monitoreo-form > .row:first-child > [class*=\"col-\"] > [class*=\"col-\"] {\n    padding-right: 0;\n  }\n\n  .tracking-monitoreo-form .LabelTracking,\n  .tracking-monitoreo-form .Label {\n    font-size: 0.75rem;\n    line-height: 1.15;\n  }\n\n  .tracking-monitoreo-form .Input,\n  .tracking-monitoreo-form .InputSelectReportSeguimihnetoSol,\n  .tracking-monitoreo-form .TextAreaReportSe2 {\n    min-width: 0 !important;\n    font-size: 0.78rem;\n  }\n\n  .tracking-monitoreo-form .TextAreaReportSe2 {\n    min-height: 62px;\n  }\n\n  .tracking-monitoreo-form .ButtonWrapper {\n    grid-column: 2;\n    flex-wrap: wrap;\n    justify-content: flex-start !important;\n    gap: 6px;\n  }\n\n  .tracking-monitoreo-form .ButtonWrapper .Button {\n    min-width: 0;\n    flex: 1 1 110px;\n    padding: 7px 10px;\n    font-size: 0.78rem;\n  }\n\n  .tracking-monitoreo-form .tracking-real-time-table-card {\n    height: 220px;\n    max-height: 220px;\n  }\n\n  .tracking-monitoreo-form .ContainerTableReportesSolicitudes {\n    height: 220px;\n    max-height: 220px;\n  }\n\n  .tracking-monitoreo-form .tracking-real-time-table th,\n  .tracking-monitoreo-form .tracking-real-time-table td {\n    padding: 4px 2px !important;\n    font-size: 0.68rem !important;\n  }\n}\n\n@media (max-width: 576px) {\n  .tracking-monitoreo-form {\n    padding: 0 10px;\n  }\n\n  .tracking-monitoreo-form > .row:first-child > [class*=\"col-\"] {\n    display: flex !important;\n    flex-direction: column !important;\n    align-items: stretch;\n    gap: 3px;\n    padding: 6px 0;\n  }\n\n  .tracking-monitoreo-form > .row:first-child > [class*=\"col-\"] > [class*=\"col-\"] {\n    width: 100% !important;\n    max-width: 100% !important;\n    padding: 0;\n  }\n\n  .tracking-monitoreo-form .InputTooltipWrapper,\n  .tracking-monitoreo-form .contToltip {\n    display: flex;\n    align-items: center;\n    min-height: 20px;\n  }\n\n  .tracking-monitoreo-form .LabelTracking,\n  .tracking-monitoreo-form .Label {\n    font-size: 0.78rem;\n    font-weight: 700;\n  }\n\n  .tracking-monitoreo-form .Input,\n  .tracking-monitoreo-form .InputSelectReportSeguimihnetoSol,\n  .tracking-monitoreo-form .TextAreaReportSe2 {\n    min-height: 38px;\n    font-size: 0.84rem;\n  }\n\n  .tracking-monitoreo-form .TextAreaReportSe2 {\n    min-height: 90px;\n  }\n\n  .tracking-monitoreo-form .ButtonWrapper {\n    display: grid !important;\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    grid-column: auto;\n    width: 100%;\n  }\n\n  .tracking-monitoreo-form .ButtonWrapper .Button {\n    width: 100%;\n    min-width: 0;\n  }\n\n  .tracking-monitoreo-form .tracking-real-time-table-card {\n    height: 240px;\n    max-height: 240px;\n    border-radius: 10px;\n  }\n\n  .tracking-monitoreo-form .ContainerTableReportesSolicitudes {\n    height: 240px;\n    max-height: 240px;\n    border-radius: 10px;\n  }\n\n  .tracking-monitoreo-form .tracking-real-time-table th,\n  .tracking-monitoreo-form .tracking-real-time-table td {\n    padding: 5px 2px !important;\n    font-size: 0.66rem !important;\n  }\n\n  /* En móvil cada reporte se presenta como una tarjeta legible. */\n  .tracking-monitoreo-form .tracking-real-time-table {\n    display: block !important;\n  }\n\n  .tracking-monitoreo-form .tracking-real-time-table colgroup,\n  .tracking-monitoreo-form .tracking-real-time-table thead {\n    display: none;\n  }\n\n  .tracking-monitoreo-form .tracking-real-time-table tbody {\n    display: grid;\n    gap: 8px;\n    padding: 8px;\n  }\n\n  .tracking-monitoreo-form .tracking-real-time-table tbody tr {\n    display: grid;\n    grid-template-columns: 64px minmax(0, 1fr) 24px;\n    gap: 3px 8px;\n    padding: 10px 8px;\n    border: 1px solid #e1eaf2;\n    border-radius: 10px;\n    background: #fff;\n    box-shadow: 0 3px 10px rgba(15, 23, 42, 0.07);\n  }\n\n  .tracking-monitoreo-form .tracking-real-time-table tbody td {\n    display: block;\n    width: auto !important;\n    max-width: none;\n    padding: 0 !important;\n    border: 0;\n    font-size: 0.72rem !important;\n    line-height: 1.25;\n    overflow: visible;\n  }\n\n  .tracking-monitoreo-form .tracking-real-time-table tbody td::before {\n    display: block;\n    margin-bottom: 2px;\n    color: #71859a;\n    font-size: 0.56rem;\n    font-weight: 700;\n    letter-spacing: 0.02em;\n    text-transform: uppercase;\n  }\n\n  .tracking-monitoreo-form .tracking-real-time-table tbody td:nth-child(1) {\n    grid-column: 1;\n    grid-row: 1 / span 5;\n    align-self: start;\n    color: #173b60;\n    font-weight: 700;\n  }\n\n  .tracking-monitoreo-form .tracking-real-time-table tbody td:nth-child(1)::before { content: \"Fecha\"; }\n  .tracking-monitoreo-form .tracking-real-time-table tbody td:nth-child(2) { grid-column: 2; grid-row: 1; }\n  .tracking-monitoreo-form .tracking-real-time-table tbody td:nth-child(2)::before { content: \"Acción\"; }\n  .tracking-monitoreo-form .tracking-real-time-table tbody td:nth-child(3) { grid-column: 2; grid-row: 2; }\n  .tracking-monitoreo-form .tracking-real-time-table tbody td:nth-child(3)::before { content: \"Estado\"; }\n  .tracking-monitoreo-form .tracking-real-time-table tbody td:nth-child(4) { grid-column: 2; grid-row: 3; }\n  .tracking-monitoreo-form .tracking-real-time-table tbody td:nth-child(4)::before { content: \"Ubicación\"; }\n  .tracking-monitoreo-form .tracking-real-time-table tbody td:nth-child(5) { grid-column: 2; grid-row: 4; }\n  .tracking-monitoreo-form .tracking-real-time-table tbody td:nth-child(5)::before { content: \"Observación\"; }\n  .tracking-monitoreo-form .tracking-real-time-table tbody td:nth-child(6) { grid-column: 2; grid-row: 5; }\n  .tracking-monitoreo-form .tracking-real-time-table tbody td:nth-child(6)::before { content: \"Usuario\"; }\n  .tracking-monitoreo-form .tracking-real-time-table tbody td:nth-child(7) {\n    grid-column: 3;\n    grid-row: 1 / span 5;\n    align-self: start;\n  }\n\n  .tracking-monitoreo-form .tracking-real-time-table tbody td:nth-child(7)::before {\n    content: none;\n  }\n}\n\n@media (max-width: 360px) {\n  .tracking-monitoreo-form {\n    padding: 0 6px;\n  }\n\n  .tracking-monitoreo-form .ButtonWrapper {\n    grid-template-columns: 1fr;\n  }\n\n  .tracking-monitoreo-form .tracking-real-time-table th,\n  .tracking-monitoreo-form .tracking-real-time-table td {\n    font-size: 0.60rem !important;\n  }\n}\n\n@media (max-width: 480px) {\n  .tracking-monitoreo-form > .row:first-child > [class*=\"col-\"] {\n    grid-template-columns: 96px minmax(0, 1fr);\n    gap: 4px;\n  }\n\n  .tracking-monitoreo-form .LabelTracking,\n  .tracking-monitoreo-form .Label {\n    font-size: 0.68rem;\n  }\n\n  .tracking-monitoreo-form .Input,\n  .tracking-monitoreo-form .InputSelectReportSeguimihnetoSol,\n  .tracking-monitoreo-form .TextAreaReportSe2 {\n    font-size: 0.7rem;\n  }\n\n  .tracking-monitoreo-form .tracking-real-time-table th,\n  .tracking-monitoreo-form .tracking-real-time-table td {\n    font-size: 0.62rem !important;\n  }\n}\n\n/* Lista responsive para móviles y tablets pequeñas. */\n@media (max-width: 768px) {\n  .tracking-monitoreo-form .ContainerTableReportesSolicitudes,\n  .tracking-monitoreo-form .tracking-real-time-table-card {\n    height: 250px !important;\n    max-height: 250px !important;\n    overflow: hidden !important;\n  }\n\n  .tracking-monitoreo-form .tracking-real-time-table-scroll {\n    height: 100% !important;\n    max-height: none !important;\n    overflow-x: hidden !important;\n    overflow-y: auto !important;\n    scrollbar-width: thin;\n    scrollbar-color: #9eb4c5 transparent;\n  }\n\n  .tracking-monitoreo-form .tracking-real-time-table-scroll::-webkit-scrollbar {\n    width: 5px;\n    height: 0;\n  }\n\n  .tracking-monitoreo-form .tracking-real-time-table-scroll::-webkit-scrollbar-track {\n    background: transparent;\n  }\n\n  .tracking-monitoreo-form .tracking-real-time-table-scroll::-webkit-scrollbar-thumb {\n    border-radius: 999px;\n    background: #9eb4c5;\n  }\n\n  .tracking-monitoreo-form .tracking-real-time-table {\n    display: block !important;\n    width: 100% !important;\n  }\n\n  .tracking-monitoreo-form .tracking-real-time-table colgroup,\n  .tracking-monitoreo-form .tracking-real-time-table thead {\n    display: none;\n  }\n\n  .tracking-monitoreo-form .tracking-real-time-table tbody {\n    display: grid;\n    gap: 8px;\n    padding: 8px;\n  }\n\n  .tracking-monitoreo-form .tracking-real-time-table tbody tr {\n    display: grid;\n    grid-template-columns: 62px minmax(0, 1fr) 24px;\n    gap: 4px 8px;\n    padding: 10px 8px;\n    border: 1px solid #e1eaf2;\n    border-radius: 10px;\n    background: #fff;\n    box-shadow: 0 3px 10px rgba(15, 23, 42, 0.07);\n  }\n\n  .tracking-monitoreo-form .tracking-real-time-table tbody td {\n    display: block;\n    width: auto !important;\n    max-width: none;\n    padding: 0 !important;\n    border: 0;\n    font-size: 0.7rem !important;\n    line-height: 1.25;\n    overflow: visible;\n    white-space: normal !important;\n    overflow-wrap: anywhere;\n  }\n\n  .tracking-monitoreo-form .tracking-real-time-table tbody td::before {\n    display: block;\n    margin-bottom: 2px;\n    color: #71859a;\n    font-size: 0.54rem;\n    font-weight: 700;\n    letter-spacing: 0.02em;\n    text-transform: uppercase;\n  }\n\n  .tracking-monitoreo-form .tracking-real-time-table tbody td:nth-child(1) {\n    grid-column: 1;\n    grid-row: 1 / span 5;\n    align-self: start;\n    color: #173b60;\n    font-weight: 700;\n  }\n\n  .tracking-monitoreo-form .tracking-real-time-table tbody td:nth-child(1)::before { content: \"Fecha\"; }\n  .tracking-monitoreo-form .tracking-real-time-table tbody td:nth-child(2) { grid-column: 2; grid-row: 1; }\n  .tracking-monitoreo-form .tracking-real-time-table tbody td:nth-child(2)::before { content: \"Acción\"; }\n  .tracking-monitoreo-form .tracking-real-time-table tbody td:nth-child(3) { grid-column: 2; grid-row: 2; }\n  .tracking-monitoreo-form .tracking-real-time-table tbody td:nth-child(3)::before { content: \"Estado\"; }\n  .tracking-monitoreo-form .tracking-real-time-table tbody td:nth-child(4) { grid-column: 2; grid-row: 3; }\n  .tracking-monitoreo-form .tracking-real-time-table tbody td:nth-child(4)::before { content: \"Ubicación\"; }\n  .tracking-monitoreo-form .tracking-real-time-table tbody td:nth-child(5) { grid-column: 2; grid-row: 4; }\n  .tracking-monitoreo-form .tracking-real-time-table tbody td:nth-child(5)::before { content: \"Observación\"; }\n  .tracking-monitoreo-form .tracking-real-time-table tbody td:nth-child(6) { grid-column: 2; grid-row: 5; }\n  .tracking-monitoreo-form .tracking-real-time-table tbody td:nth-child(6)::before { content: \"Usuario\"; }\n  .tracking-monitoreo-form .tracking-real-time-table tbody td:nth-child(7) {\n    grid-column: 3;\n    grid-row: 1 / span 5;\n    align-self: start;\n  }\n\n  .tracking-monitoreo-form .tracking-real-time-table tbody td:nth-child(7)::before {\n    content: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
